document.querySelectorAll('.menu-item-has-children').forEach(item => {
  item.addEventListener('mousedown', e => {
    e.preventDefault();
    e.stopPropagation();
  });

  item.addEventListener('click', e => {
    e.preventDefault();
    e.stopPropagation();
  });

  item.querySelectorAll('.sub-menu a').forEach(link => {
    link.addEventListener('click', e => {
      e.stopPropagation();
    });
  });
});
